import React from 'react';

export default function PrinciplesOfExcellenceModalContent() {
  return (
    <>
      <h3>Principles of Excellence</h3>
      <p>
        The{' '}
        <a
          title="Principles of Excellence"
          href="https://www.govinfo.gov/content/pkg/FR-2012-05-02/pdf/2012-10715.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Principles of Excellence
        </a>{' '}
        are guidelines for educational institutions receiving federal funding.
        Schools that agree to participate will:
      </p>
      <ul>
        <li>
          End fraudulent and aggressive recruiting techniques and
          misrepresentation.
        </li>
        <li>
          Provide students with a personalized form covering the total cost of
          an education program.
        </li>
        <li>
          Provide educational plans for all military and Veteran education
          beneficiaries.
        </li>
        <li>
          Provide accommodations for service members and Reservists absent due
          to service requirements.
        </li>
        <li>Assign a point of contact for academic and financial advising.</li>
        <li>
          Make sure all new programs are accredited before they enroll students.
        </li>
        <li>Align institutional refund policies with those under Title IV.</li>
      </ul>
      <p>
        Foreign schools, on-the-job training and apprenticeship programs,
        residency and internship programs, and those who don’t charge tuition
        and fees aren’t asked to comply with the Principles of Excellence.
      </p>
      <p>
        We try to make sure this information is accurate, but prospective
        students should only use this as a planning tool. Principles of
        Excellence schools are updated quarterly.
      </p>
    </>
  );
}
